import { useSelector } from 'react-redux';
import type { DroneEntity } from '@src/core/features';
import { selectDrone } from '../redux';

interface UseSelectedFleetDroneResult {
  selectedDrone: DroneEntity | null;
  droneId: number | undefined;
  hasDrone: boolean;
}

export function useSelectedFleetDrone(): UseSelectedFleetDroneResult {
  const selectedDrone = useSelector(selectDrone);
  const droneId = selectedDrone?.id;

  return {
    selectedDrone,
    droneId,
    hasDrone: droneId != null,
  };
}
